import React from 'react';
import dayjs from 'dayjs';
import { DatePicker, Input } from 'antd';

const ActivePeriodFields = ({ formData, updateField, errorStartDate, errorEndDate, errorDateOrder }) => {
  const startValue = formData?.activeStartDate ? dayjs(formData.activeStartDate) : null;
  const endValue = formData?.activeEndDate ? dayjs(formData.activeEndDate) : null;
  const disableEndDate = (current) => startValue
    && current
    && current.isBefore(startValue.startOf('day'));
  const disableEndTime = (current) => {
    if (!startValue || !current || !current.isSame(startValue, 'day')) return {};

    return {
      disabledHours: () => Array.from({ length: startValue.hour() }, (_, hour) => hour),
      disabledMinutes: (hour) => (hour === startValue.hour()
        ? Array.from({ length: startValue.minute() }, (_, minute) => minute)
        : []),
    };
  };

  return (
    <>
      <div className='step-group'>
        <div className='step-section-title Title-dark'>Active Period</div>
        <div className='step-subtitle mb-8'>
          Set both dates to schedule this rule, or leave both blank to keep it always on.
        </div>

        <div className='step-group d-flex d-flex-row gap-16'>
            <div className='step-group-inner DatePicker-inner step-group'>
                <div className='step-form-label'>
                  Start Date and Time{formData?.activeEndDate && <span style={{ color: '#ff4d4f' }}> *</span>}
                </div>
                <DatePicker
                value={startValue}
                showTime
                status={errorStartDate || errorDateOrder ? 'error' : undefined}
                onChange={(value) => updateField('activeStartDate', value ? value.format('YYYY-MM-DD HH:mm') : '')}
                className='Input-border InputText DatePicker-input'
                />
                {errorStartDate && <div className='step-form-hint' style={{ color: '#ff4d4f' }}>Start Date and Time is required when End Date is set.</div>}
                {errorDateOrder && <div className='step-form-hint' style={{ color: '#ff4d4f' }}>Start Date and Time must not be later than End Date and Time.</div>}
            </div>

            <div className='step-group-inner DatePicker-inner step-group'>
                <div className='step-form-label'>
                  End Date and Time{formData?.activeStartDate && <span style={{ color: '#ff4d4f' }}> *</span>}
                </div>
                <DatePicker
                value={endValue}
                showTime
                disabledDate={disableEndDate}
                disabledTime={disableEndTime}
                status={errorEndDate || errorDateOrder ? 'error' : undefined}
                onChange={(value) => updateField('activeEndDate', value ? value.format('YYYY-MM-DD HH:mm') : '')}
                className='Input-border InputText DatePicker-input'
                />
                {errorEndDate && <div className='step-form-hint' style={{ color: '#ff4d4f' }}>End Date and Time is required when Start Date is set.</div>}
            </div>
        </div>
      </div>
    </>
  );
};

export default ActivePeriodFields;
